import type { SVGProps } from 'react';
const SvgIconDashboardGuage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="#1A202C"
      d="M12 4.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m0 16.73a9.23 9.23 0 1 0 0-18.46 9.23 9.23 0 0 0 0 18.46m2.02-5.768c0-.805-.473-1.5-1.155-1.825v-6.54A.863.863 0 0 0 12 6.23a.863.863 0 0 0-.865.865v6.541A2.02 2.02 0 0 0 12 17.481a2.02 2.02 0 0 0 2.02-2.02zm-5.482-5.77a1.154 1.154 0 1 0 0-2.307 1.154 1.154 0 0 0 0 2.307M7.962 12a1.154 1.154 0 1 0-2.308 0 1.154 1.154 0 0 0 2.308 0m9.23 1.154a1.154 1.154 0 1 0 0-2.308 1.154 1.154 0 0 0 0 2.308m-.577-4.616a1.154 1.154 0 1 0-2.307 0 1.154 1.154 0 0 0 2.307 0"
    />
  </svg>
);
export default SvgIconDashboardGuage;
